import React, { useState } from 'react';
import { hot } from 'react-hot-loader';

/* COMPONENTS */
import VideoPlayer from '../../../hocs/HLSVideo/HLSVideo';

import { purifier } from '../../../utils/dom';
import s from './Video.scss';

const Video = ({ content, enableEvents = true, extraProps = null }) => {
	// Video player attributes.
	const { src, autoplay, loop, muted } = content;
	const [playerStatus, updatePlayerStatus] = useState(!autoplay);
	const isMuted = !!autoplay || !!muted || undefined;

	// Control video player or not.
	const Element = enableEvents ? 'a' : 'div';
	const wrapperProps = {};
	const videoClick = (e) => {
		const $video = e.currentTarget.querySelector('video');
		if (enableEvents) {
			e.stopPropagation();
			e.preventDefault();

			if ($video.paused) {
				$video.play();
				updatePlayerStatus(false);
			} else {
				$video.pause();
				updatePlayerStatus(true);
			}
		}
	};

	if (enableEvents) {
		wrapperProps.href = '#control-video-player';
		wrapperProps.onClick = videoClick;
	}


	return (
		<figure className={s.video}>
			<Element className={s.video_wrapper} {...wrapperProps}>
				{ playerStatus && <svg className={s.video_wrapper_playButton} width="45" height="72" viewBox="0 0 45 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M45 36L4.70468e-07 71.507L3.57459e-06 0.492956L45 36Z" fill="white" fillOpacity="0.5" /></svg> }
				<VideoPlayer className={s.video_wrapper_src} src={src} autoPlay={!!autoplay || undefined} loop={!!loop || undefined} playsInline muted={isMuted} poster={content?.poster?.url || undefined} {...extraProps} />
			</Element>
			{ content.caption && <figcaption className={s.video_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
		</figure>
	);
};

export default hot(module)(Video);
